module.exports = __webpack_public_path__ + "img/分区08.cee6204a.png";